import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { HudNav } from "../components/HudNav";
import { SiteFooter } from "../components/SiteFooter";

export const LineDetail = ({ t, lang, setLang }) => {
  const { id } = useParams();
  const d = t.lineDetails[Number(id) - 1];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);
  if (!d) return null;

  return (
    <div className="bg-[#050505] min-h-screen text-white antialiased">
      <HudNav t={t.nav} lang={lang} setLang={setLang} pdfLabel={t.pdf_btn} pdfBusy={t.pdf_busy} galleryLabel={t.galleryPage.title} />
      <header data-testid="line-hero" className="relative pt-16">
        <div className="relative h-[52vh] overflow-hidden">
          <img src={d.img} alt={d.title} className="w-full h-full object-cover grayscale-[0.3] opacity-70" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/60" />
          <span className="absolute top-6 left-6 md:left-10 text-xs font-mono tracking-[0.2em] uppercase bg-[#FF2A00] text-black px-3 py-1">{d.tag}</span>
        </div>
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 -mt-24 relative">
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight leading-[0.95]" data-testid="line-title">{d.title}</h1>
          <p className="mt-6 max-w-2xl text-sm md:text-base font-mono tracking-tight text-[#8A8F98] leading-relaxed">{d.intro}</p>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <p className="text-xs font-mono tracking-[0.2em] uppercase text-[#FF2A00] mb-10">// {t.detail.sheet}</p>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {d.groups.map((g, i) => (
            <Reveal key={g.t} delay={i * 0.08}>
              <div data-testid={`line-group-${i}`} className="border border-[#272A2E] bg-[#0A0B0D] p-8 h-full"
                style={{ clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 24px), calc(100% - 24px) 100%, 0 100%)" }}>
                <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white">{g.t}</h3>
                <ul className="mt-6 space-y-4">
                  {g.items.map((it, j) => (
                    <li key={j} className="flex gap-4 text-sm font-mono tracking-tight text-[#8A8F98] leading-relaxed">
                      <span className="text-[#FF2A00] shrink-0">+</span>{it}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div data-testid="line-common" className="mt-16 border-l-2 border-[#FF2A00] bg-[#0A0B0D] p-8 md:p-10">
            <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white">{t.detail.common_t}</h3>
            <ul className="mt-6 grid md:grid-cols-2 gap-4">
              {t.detail.common.map((c, i) => (
                <li key={i} className="flex gap-4 text-sm font-mono tracking-tight text-[#8A8F98] leading-relaxed">
                  <span className="text-[#FF2A00] shrink-0">+</span>{c}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <div className="mt-16 flex flex-wrap gap-4">
          <Link to="/" data-testid="line-back" className="text-xs font-mono tracking-[0.15em] uppercase border border-[#272A2E] text-[#8A8F98] px-6 py-4 hover:text-white hover:border-white transition-colors duration-300">
            {t.detail.back}
          </Link>
          <a href="/#contact" data-testid="line-cta" className="text-xs font-mono tracking-[0.15em] uppercase bg-[#FF2A00] text-black px-6 py-4 hover:bg-white transition-colors duration-300">
            {t.detail.cta}
          </a>
        </div>
      </main>
      <SiteFooter t={t} />
    </div>
  );
};
